import { DeckColumn } from '@services/api/deckManagement/graphql/schema/API';
import { isEmpty, isNil, maxBy } from 'lodash';

/**
 * Gets the number of block headers defined for a Page, given a list of Page deck columns
 * @param deckColumns
 */
const getNumberOfBlockHeaders = (deckColumns: DeckColumn[]) => {
  if (isNil(deckColumns) || isEmpty(deckColumns)) return 1;

  return maxBy(deckColumns, (deckColumn) => deckColumn?.block_id || 1)?.block_id ?? 1;
};

// TODO: On next add of helper function, remove this default export
export default getNumberOfBlockHeaders;
